import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-djzx",
  "use": "icon-djzx-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-djzx\"><defs><style type=\"text/css\"></style></defs><path d=\"M800 144H608V80c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v64H224c-52.9 0-96 43.1-96 96v640c0 52.9 43.1 96 96 96h576c52.9 0 96-43.1 96-96V240c0-52.9-43.1-96-96-96z m-480 64h384v57H320v-57z m512 672c0 17.6-14.4 32-32 32H224c-17.6 0-32-14.4-32-32V240c0-17.6 14.4-32 32-32h32v121h512V208h32c17.6 0 32 14.4 32 32v640z\" p-id=\"6318\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol